<script>
	export let note = undefined
</script>

<div style="color: red" title={note}>
	<slot />
</div>
